import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharingGroups = z.any()
export type TagsGetEdc_sharingGroups = z.infer<typeof tagsGetEdc_sharingGroups>

export const querystringGetEdc_sharingGroups = z.object({ "collectionPointId": z.string().optional() })
export type QuerystringGetEdc_sharingGroups = z.infer<typeof querystringGetEdc_sharingGroups>

export const responseGetEdc_sharingGroups = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "participantCount": z.number() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetEdc_sharingGroups = z.infer<typeof responseGetEdc_sharingGroups>

interface IGetEdc_sharingGroups extends BaseMethodType {
  tags: TagsGetEdc_sharingGroups,
  querystring: QuerystringGetEdc_sharingGroups,
  response: ResponseGetEdc_sharingGroups
}
export const URL = '/edc-sharing/groups'
export const validation = {
  get: {
    tags: tagsGetEdc_sharingGroups,
    querystring: querystringGetEdc_sharingGroups,
    response: responseGetEdc_sharingGroups
  }
}
export interface Edc_sharingGroups extends BaseRouteType {
  get: IGetEdc_sharingGroups
}